<div class="pos-relative">
  <app-entity-contact-buttons [entityId]="entityId"
                              [campaignId]="campaignId"
                              class="wlCore__contact">
  </app-entity-contact-buttons>
</div>
<mat-divider class="mt-0100"></mat-divider>
<app-entity-toplines [entityId]="entityId"
                     [campaignId]="campaignId"
                     class="toplines d-block ml-0 mb-0 pl-0 w-100 border-0">
</app-entity-toplines>
